import { Injectable } from '@angular/core';
import { HttpClient } from './http-client';
import { Http, Headers, Response } from '@angular/http';
import { dateToUnixTime } from '../utils';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { FileSaverService } from './file-saver-service';
export const COM_DIALOG_STATE = {
  NEW: 'New',
  EDIT: 'Edit',
  CLONE: 'Clone'
};

@Injectable()


export class ComunicacionService {

  constructor(private httpClient: HttpClient,
              private http: Http,
              private fileSaverService: FileSaverService) {
  }

  getComunicaciones(filter, resetPage) {

    const object = {
      FechaFrom: filter.FechaFrom === null ? 0 : dateToUnixTime(filter.FechaFrom),
      FechaTo: filter.FechaTo === null ? 0 : dateToUnixTime(filter.FechaTo),
      PageSize: filter.PageSize,
      PageNumber: resetPage ? 0 : filter.PageNumber,
      AscendingOrder: filter.AscendingOrder,
      ColumnOrder: filter.ColumnOrder.charAt(0).toUpperCase() + filter.ColumnOrder.slice(1),
      UserId: filter.UserId,
      FilterTipo: filter.FilterTipo,
      FilterPrioridad: filter.FilterPrioridad,
      FilterAutor: filter.FilterAutor,
      ConAdjunto: filter.ConAdjunto,
      SearchString: filter.SearchString,
      Papelera: filter.Papelera,
      Propios: filter.Propios
    };

    return this.httpClient.post(`/api/comunicacion/filter`, object)
      .map((response: Response) => {
        return response.json().ResponseData;
      });
  }

  getComunicacionTipos() {
    return this.httpClient.get(`/api/comunicacion/tipos`)
      .map((response: Response) => {
        return response.json().ResponseData;
      });
  }

  getComunicacionById(id: number) {
    return this.httpClient.get(`/api/comunicacion/${id}`)
      .map((response: Response) => {
        return response.json().ResponseData;
      });
  }

  getComunicacionAreas() {
    return this.httpClient.get(`/api/area`)
      .map((response: Response) => {
        return response.json().ResponseData;
      });
  }

  getColaboradoresByRol(id: number) {
    return this.httpClient.get(`/api/rol/colaboradores/${id}`)
      .map((response: Response) => {
        return response.json().ResponseData;
      });
  }

  saveComunicacionNoFileAdded(titulo: string,
                              autor: number,
                              tipo: number,
                              prioridad: number,
                              colaboradores = [],
                              clientes = [],
                              descripcion: string,
                              area: number) {
    let object: any = {};

    object = {
    Titulo : titulo,
    AutorId : autor,
    TipoComunicacionId: tipo,
    PrioridadComunicacionId: prioridad,
    ColaboradoresIds: colaboradores,
    ClientesIds : clientes,
    Descripcion : descripcion,
    AreaId : area,
    FilePath : null
    };

    return this.httpClient.post(`/api/comunicacion`, object)
      .map((response: Response) => {
        return response.json().ResponseData;
      });
  }

  updateComunicacion(id: number,
                      titulo: string,
                      autor: number,
                      tipo: number,
                      prioridad: number,
                      colaboradores = [],
                      clientes = [],
                      descripcion: string,
                      area: number,
                      filePath: string) {

    const object = {
      Id: id,
      Titulo : titulo,
      AutorId : autor,
      TipoComunicacionId: tipo,
      PrioridadComunicacionId: prioridad,
      ColaboradoresIds: colaboradores,
      ClientesIds : clientes,
      Descripcion : descripcion,
      AreaId : area,
      FilePath : filePath,
      FileName : filePath
    };

    return this.httpClient.put(`/api/comunicacion`, object)
      .map((response: Response) => {
        return response.json().ResponseData;
      });
  }

  saveComunicacionWithFile(titulo: string,
                              autor: number,
                              tipo: number,
                              prioridad: number,
                              colaboradores = [],
                              clientes = [],
                              descripcion: string,
                              area: number,
                              formData: any) {

    const url = environment.API_URL + '/api/comunicacion/upload-file';

    const object = {
      Titulo : titulo,
      AutorId : autor,
      TipoComunicacionId: tipo,
      PrioridadComunicacionId: prioridad,
      ColaboradoresIds: colaboradores,
      ClientesIds : clientes,
      Descripcion : descripcion,
      AreaId : area
    };

    let headers = new Headers();
    headers.append('Authorization', 'Bearer ' + localStorage.getItem('token'));

    // el formData esta repitiendo el viewModel cada vez que enviamos. Asi que lo limpiamos.
    if (formData.has('viewModel')) {
      formData.delete('viewModel');
    }

    // Lo transformamos en objeto json con el siguiente metodo JSON.stringify(object)
    formData.append('viewModel', JSON.stringify(object));

    return this.http.post(url, formData, {
      headers: headers
    }).catch(error => {
      return Observable.throw(error);
    });
  }

  markAsDownloaded(id) {
    const userId = localStorage.getItem('userId');
    return this.httpClient.get(`/api/comunicacion/mark-as-downloaded/${id}/${userId}`)
      .map((response: Response) => {
        return response.json().ResponseData;
      });
  }

  downloadFile(id: number){
    return this.httpClient.getFiles(`/api/comunicacion/get-attachment/${id}`, null)
      .map((response: Response ) => {
        return this.fileSaverService.SaveToFileSystem(response);
      });
  }

  deleteComunicacion(id: number) {
    return this.httpClient.delete(`/api/comunicacion/${id}`)
      .map((response: Response) => {
        return response.json().ResponseData;
      });
  }

  cloneComuncicacion(id: number,
                     titulo: string,
                     autor: number,
                     tipo: number,
                     prioridad: number,
                     colaboradores = [],
                     clientes = [],
                     descripcion: string,
                     area: number) {
    let object: any = {};

    object = {
      Titulo : titulo,
      AutorId : autor,
      TipoComunicacionId: tipo,
      PrioridadComunicacionId: prioridad,
      ColaboradoresIds: colaboradores,
      ClientesIds : clientes,
      Descripcion : descripcion,
      AreaId : area,
      FilePath : null,
      Id: id
    };

    return this.httpClient.post(`/api/comunicacion/clone`, object)
      .map((response: Response) => {
        return response.json().ResponseData;
      });
  }

  updateComunicacionWithFile(id: number,
                             titulo: string,
                             autor: number,
                             tipo: number,
                             prioridad: number,
                             colaboradores = [],
                             clientes = [],
                             descripcion: string,
                             area: number,
                             formData: any) {

    const url = environment.API_URL + '/api/comunicacion/update-uploaded-file';

    const object = {
      Titulo : titulo,
      AutorId : autor,
      TipoComunicacionId: tipo,
      PrioridadComunicacionId: prioridad,
      ColaboradoresIds: colaboradores,
      ClientesIds : clientes,
      Descripcion : descripcion,
      AreaId : area,
      Id: id
    };

    let headers = new Headers();
    headers.append('Authorization', 'Bearer ' + localStorage.getItem('token'));

    // el formData esta repitiendo el viewModel cada vez que enviamos. Asi que lo limpiamos.
    if (formData.has('viewModel')) {
      formData.delete('viewModel');
    }

    // Lo transformamos en objeto json con el siguiente metodo JSON.stringify(object)
    formData.append('viewModel', JSON.stringify(object));

    return this.http.put(url, formData, {
      headers: headers
    }).catch(error => {
      return Observable.throw(error);
    });
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/comunicacion-service.ts